var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"long-text-tooltip"},[_c('el-popover',{attrs:{"placement":"top","width":"300","trigger":"hover","content":_vm.text,"popper-class":"long-text-popover"}},[_c('span',{staticClass:"text-trigger",attrs:{"slot":"reference"},slot:"reference"},[_vm._v(" "+_vm._s(_vm.displayText)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }